module.exports = __webpack_public_path__ + "static/img/gjxx.e16413bb.png";